import { React } from 'react';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Divider, Typography } from '@mui/material';
import priceFormatter from '../../../../util/priceFormatter';
import useStyles from './style';
import { PrepayPayToday } from '../../shared/CustomIcons.styled';

/**
 * @name PrepayCartSummary - Prepat cart summary
 * @param {object} summaryData - Local cms data object containing title ,subtitle etc
 * @returns {JSX.Element} - Returns Prepay cart cost details
 */
const PrepayCartSummary = ({ cartData, summaryData }) => {
  const theme = useTheme();
  const style = useStyles(theme);
  return (
    <>
      <Divider />
      <Stack direction='row' justifyContent='space-between' sx={style.payAmount}>
        <Stack direction='row' alignItems='flex-end'>
          <PrepayPayToday />
          <Typography variant='subtitle1' sx={{ ...style.subText, pl: '0.25rem' }}>
            {summaryData?.prepaySummary?.payToday}
          </Typography>
        </Stack>
        <Typography variant='h6' sx={style.subText}>
          {priceFormatter(parseFloat(cartData?.payTodayTotal))}
        </Typography>
      </Stack>
    </>
  );
};
export default PrepayCartSummary;
